import React, { useEffect, useState } from 'react';
import { Box, TextField, Link , FormControlLabel, Checkbox, FormGroup, Grid, Button, Typography, Paper, MenuItem, IconButton, Divider } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { getParentData ,submitAdmissionForm } from '../api';
import { styled } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import ThankYouModal from './ThankyouModal';

const FancyButton = styled(Button)({
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
});

const FancyUploadSection = ({ onFileChange, filePreview }) => (
    <>
        <Divider sx={{ my: 4 }} />
        <Typography variant="h6" gutterBottom>
            Upload Parent/Guardian Signature
        </Typography>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
                {filePreview && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                        <img src={filePreview} alt="Signature" style={{ maxHeight: '100px', border: '1px solid #ccc', borderRadius: '5px' }} />
                    </Box>
                )}
            </Grid>
            <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <FancyButton
                    variant="contained"
                    component="label"
                    startIcon={<PhotoCamera />}
                >
                    Upload Signature
                    <input type="file" hidden onChange={onFileChange} />
                </FancyButton>
            </Grid>
        </Grid>
    </>
);

const data = [
    { age: 2, class: "Play group", section: "IB PYP" },
    { age: 3, class: "Nursery", section: "IB PYP" },
    { age: 4, class: "Pre-Kindergarten (Pre-K)", section: "IB PYP" },
    { age: 5, class: "Kindergarten (K)", section: "IB PYP" },
    { age: 6, class: "Year 1 (PYP 1)", section: "IB PYP" },
    { age: 7, class: "Year 2 (PYP 2)", section: "IB PYP" },
    { age: 8, class: "Year 3 (PYP 3)", section: "IB PYP" },
    { age: 9, class: "Year 4 (PYP 4)", section: "IB PYP" },
    { age: 10, class: "Year 5 (PYP 5)", section: "IB PYP" },
    { age: 11, class: "Year 6 (MYP 1)", section: "IB MYP" },
    { age: 12, class: "Year 7 (MYP 2)", section: "IB MYP" },
    { age: 13, class: "Year 8 (MYP 3)", section: "IB MYP" },
    { age: 14, class: "Year 9 (MYP 4)", section: "IB MYP" },
    { age: 15, class: "Year 10 (MYP 5)", section: "IB MYP" },
    { age: 16, class: "Year 11 (DP 1)", section: "IB DP" },
    { age: 17, class: "Year 12 (DP 2)", section: "IB DP" }
  ];
  
  const calculateAge = (dob) => {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
      }
      return age;
  };


const AdmissionForm = ({ onClose }) => {
    const [signatureImage, setSignatureImage] = useState(null);
    const [signatureImageFile, setSignatureImageFile] = useState(null);
    const navigate = useNavigate();
    const handleSignatureFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.size <= 2 * 1024 * 1024) {
            setSignatureImage(URL.createObjectURL(file));
            setSignatureImageFile(file);
        } else {
            toast.error('File size should be 2MB or less');
        }
    };

    const [isModalVisible, setModalVisible] = useState(false);
    const closeModal = () => {
        setModalVisible(false);  
      };

    const [childFirstName, setChildFirstName] = useState('');
    const [childLastName, setChildLastName] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [email, setEmail] = useState('');
    const [gender, setGender] = useState('');
    const [childImage, setChildImage] = useState(null);
    const [childImageFile, setChildImageFile] = useState(null);
    const [childClass, setChildClass] = useState('');
    const [admissionRequiredFor, setAdmissionRequiredFor] = useState('');
    const [firstNationality, setFirstNationality] = useState('');
    const [secondNationality, setSecondNationality] = useState('');
    const [submittingRelative ,setsubmittingRelative] = useState('');
    const [parentInfo, setParentInfo] = useState({
        motherName: '',
        motherOccupation: '',
        motherDesignation: '',
        motherOrganization: '',
        motherOfficePhone: '',
        motherFax: '',
        motherCell: '',
        motherEmail: '',
        fatherName: '',
        fatherOccupation: '',
        fatherDesignation: '',
        fatherOrganization: '',
        fatherOfficePhone: '',
        fatherFax: '',
        fatherCell: '',
        fatherEmail: '',
        guardianName: '',
        guardianOccupation: '',
        guardianDesignation: '',
        guardianOrganization: '',
        guardianOfficePhone: '',
        guardianFax: '',
        guardianCell: '',
        guardianEmail: '',
    });
    const [addressInfo, setAddressInfo] = useState({
        presentAddress: '',
        permanentAddress: '',
        phone1: '',
        phone2: '',
        emergencyContactNumber: '',
        emergencyContactName: '',
    });
    const [previousSchools, setPreviousSchools] = useState([]);

    const userId = localStorage.getItem('userID');
    useEffect(() => {
        if (userId) {
            getParentData(userId)
                .then(data => {
                    if (data.relationship === 'Father') {
                        setsubmittingRelative(data.relationship)
                        setParentInfo(prev => ({ ...prev, fatherName: data.username, fatherOccupation: data.occupation, fatherDesignation: data.designation, fatherOrganization: data.organisation, fatherCell: data.phone_number, fatherEmail: data.email }));
                    } else if (data.relationship === 'Mother') {
                        setsubmittingRelative(data.relationship)
                        setParentInfo(prev => ({ ...prev, motherName: data.username, motherOccupation: data.occupation, motherDesignation: data.designation, motherOrganization: data.organisation, motherCell: data.phone_number, motherEmail: data.email }));
                    } else {
                        setsubmittingRelative(data.relationship)
                        setParentInfo(prev => ({ ...prev, guardianName: data.username, guardianOccupation: data.occupation, guardianDesignation: data.designation, guardianOrganization: data.organisation, guardianCell: data.phone_number, guardianEmail: data.email }));
                    }
                })
                .catch(error => {
                    console.error('Error fetching parent data:', error);
                });
        }
    }, [userId]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.size <= 2 * 1024 * 1024) {
            setChildImage(URL.createObjectURL(file));
            setChildImageFile(file);
        } else {
            toast.error('File size should be 2MB or less');
        }
    };
    const handleGenderChange = (event) => {
        setGender(event.target.name);
    };

    const handleAddSchool = () => {
        setPreviousSchools(prev => [...prev, { name: '', gradeFrom: '', gradeTo: '', dateFrom: '', dateTo: '' }]);
    };

    const handleRemoveSchool = (index) => {
        setPreviousSchools(prev => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = async  (event) => {
        event.preventDefault();
    
        // Check required fields
        const requiredFields = {
            childFirstName,
            childLastName,
            dateOfBirth,
            email,
            gender,
            childClass,
            admissionRequiredFor,
            firstNationality,
            childImage,
            signatureImage,
            "Mother's Name": parentInfo.motherName,
            "Mother's Occupation": parentInfo.motherOccupation,
            "Mother's Designation": parentInfo.motherDesignation,
            "Mother's Organization": parentInfo.motherOrganization,
            "Mother's Cell": parentInfo.motherCell,
            "Mother's Email": parentInfo.motherEmail,
            "Father's Name": parentInfo.fatherName,
            "Father's Occupation": parentInfo.fatherOccupation,
            "Father's Designation": parentInfo.fatherDesignation,
            "Father's Organization": parentInfo.fatherOrganization,
            "Father's Office Phone": parentInfo.fatherOfficePhone,
            "Father's Cell": parentInfo.fatherCell,
            "Father's Email": parentInfo.fatherEmail,
            "Present Address": addressInfo.presentAddress,
            "Permanent Address": addressInfo.permanentAddress,
            "Phone 1": addressInfo.phone1,
            "Phone 2": addressInfo.phone2,
            "Emergency Contact Number": addressInfo.emergencyContactNumber,
            "Emergency Contact Name": addressInfo.emergencyContactName
        };
    
        let missingFields = [];
    
        for (const [key, value] of Object.entries(requiredFields)) {
            if (!value) {
                missingFields.push(key);
            }
        }
    
        if (missingFields.length > 0) {
            toast.error(`Please fill out the following required fields: ${missingFields.join(', ')}`);
            return;
        }
    
        // Prepare data for submission
        const formData = {
            childFirstName,
            childLastName,
            dateOfBirth,
            email,
            gender,
            childClass,
            admissionRequiredFor,
            firstNationality,
            childImageFile,
            parentInfo,
            addressInfo,
            previousSchools,
            submittingRelative,
            signatureImageFile
        };
    
        // Log JSON output of the data
        console.log(formData);
    
        try {
            await submitAdmissionForm(formData);
            setModalVisible(true);  // Show modal on successful form submission
          } catch (error) {
            console.error('Form submission failed:', error);
          }
    };

    const classOptions = [
        "Year 1 (PYP 1)", 
"Year 2 (PYP 2)", 
"Year 3 (PYP 3)", 
"Year 4 (PYP 4)", 
"Year 5 (PYP 5)", 
"Year 6 (MYP 1)", 
"Year 7 (MYP 2)", 
"Year 8 (MYP 3)", 
"Year 9 (MYP 4)", 
"Year 10 (MYP 5)",
"Year 11 (DP 1)", 
"Year 12 (DP 2)", 
        "Kindergarten (K)", "Pre-Kindergarten (Pre-K)", "Nursery", "Play group"
    ];

    const admissionOptions = ["NOW", "Term 1 ( August intake)", "Term 2 (January intake)"];

    

    useEffect(() => {
        if (dateOfBirth) {
            const age = calculateAge(dateOfBirth);
            const matchingClass = data.find(d => d.age === age);
            if (matchingClass) {
                setChildClass(matchingClass.class);
                setAdmissionRequiredFor('NOW');
            }
        }
    }, [dateOfBirth]);

    return (
        <Paper sx={{ p: 4, mt: 2 }}>
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Typography variant="h6" gutterBottom>
                Register Child
            </Typography>
            <Box component="form" onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Child First Name"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={childFirstName}
                            onChange={(e) => setChildFirstName(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Child Last Name"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={childLastName}
                            onChange={(e) => setChildLastName(e.target.value)}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Date of Birth"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={dateOfBirth}
                            onChange={(e) => setDateOfBirth(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <TextField
                            label="Email"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="body1">Gender :</Typography>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={gender === 'Male'}
                                            onChange={handleGenderChange}
                                            name="Male"
                                            style={{ color: 'green' }}
                                        />
                                    }
                                    label="Male"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={gender === 'Female'}
                                            onChange={handleGenderChange}
                                            name="Female"
                                            style={{ color: 'green' }}
                                        />
                                    }
                                    label="Female"
                                />
                            </FormGroup>
                        </Box>
                    </Grid>
                </Grid>

                <Grid container spacing={1}>
                    <Grid item xs={12} sm={3}>
                        <Box sx={{ mt: 2 }}>
                            {childImage && (
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="body2">Uploaded Picture:</Typography>
                                    <img src={childImage} alt="Child" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                </Box>
                            )}
                            <Typography variant="body1">Upload Picture (Max size 2MB, blue background)</Typography>

                            <Button
                                variant="contained"
                                component="label"
                                startIcon={<PhotoCamera />}
                                sx={{ mt: 1, mb: 2 }}
                            >
                                Upload
                                <input type="file" hidden onChange={handleFileChange} />
                            </Button>

                        </Box>
                    </Grid>

                    
  <Grid item xs={12} sm={2}>
    <TextField
      select
      label="Class"
      variant="outlined"
      fullWidth
      margin="normal"
      value={childClass}
      onChange={(e) => setChildClass(e.target.value)}
      sx={{ marginTop: childImage ? '80px' : '16px' }} // Adjust marginTop based on image upload
    >
      {classOptions.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  </Grid>

  <Grid item xs={12} sm={3}>
    <TextField
      select
      label="Admission Required For"
      variant="outlined"
      fullWidth
      margin="normal"
      value={admissionRequiredFor}
      onChange={(e) => setAdmissionRequiredFor(e.target.value)}
      sx={{ marginTop: childImage ? '80px' : '16px' }} // Adjust marginTop based on image upload
    >
      {admissionOptions.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
    <Typography variant="body1" sx={{ mt: 2 }}>
      Check the{' '}
      <Link 
        component="button"
        variant="body1"
        onClick={() => navigate('/ageChart')}
        sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
      >
        age guide chart for admission criteria
      </Link>{' '}
      
    </Typography>
  </Grid>


                    <Grid item xs={12} sm={2}>
                        <TextField
                            label="First Nationality"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={firstNationality}
                            onChange={(e) => setFirstNationality(e.target.value)}
                            sx={{ marginTop: childImage ? '80px' : '16px' }} // Adjust marginTop based on image upload
                        />
                    </Grid>

                    <Grid item xs={12} sm={2}>
                        <TextField
                            label="Second Nationality"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={secondNationality}
                            onChange={(e) => setSecondNationality(e.target.value)}
                            sx={{ marginTop: childImage ? '80px' : '16px' }} // Adjust marginTop based on image upload
                        />
                    </Grid>
                </Grid>

                <Divider sx={{ my: 4 }} />
                <Typography variant="h6" gutterBottom>
                    Parental Info

                </Typography>
                <br />
                <Grid container spacing={2}>
                    {/* Mother's Information Section */}
                    <Typography variant="h6" gutterBottom sx={{ width: '100%' }}>
                        Mother's Information
                    </Typography>
                    {['Name', 'Occupation', 'Designation', 'Organization', 'Office Phone', 'Fax', 'Cell', 'Email'].map(field => (
                        <Grid item xs={12} sm={6} key={`mother-${field}`}>
                            <TextField
                                label={`Mother's ${field}`}
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={parentInfo[`mother${field.replace(' ', '')}`]}
                                onChange={(e) => setParentInfo(prev => ({
                                    ...prev,
                                    [`mother${field.replace(' ', '')}`]: e.target.value
                                }))}
                            />
                        </Grid>
                    ))}

                    {/* Father's Information Section */}
                    <Typography variant="h6" gutterBottom sx={{ width: '100%', mt: 4 }}>
                        Father's Information
                    </Typography>
                    {['Name', 'Occupation', 'Designation', 'Organization', 'Office Phone', 'Fax', 'Cell', 'Email'].map(field => (
                                                <Grid item xs={12} sm={6} key={`father-${field}`}>
                                                <TextField
                                                    label={`Father's ${field}`}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    value={parentInfo[`father${field.replace(' ', '')}`]}
                                                    onChange={(e) => setParentInfo(prev => ({
                                                        ...prev,
                                                        [`father${field.replace(' ', '')}`]: e.target.value
                                                    }))}
                                                />
                                            </Grid>
                                        ))}
                    
                                        {/* Guardian's Information Section (Optional) */}
                                        <Typography variant="h6" gutterBottom sx={{ width: '100%', mt: 4 }}>
                                            Guardian's Information (Optional)
                                        </Typography>
                                        {['Name', 'Occupation', 'Designation', 'Organization', 'Office Phone', 'Fax', 'Cell', 'Email'].map(field => (
                                            <Grid item xs={12} sm={6} key={`guardian-${field}`}>
                                                <TextField
                                                    label={`Guardian's ${field}`}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    value={parentInfo[`guardian${field.replace(' ', '')}`]}
                                                    onChange={(e) => setParentInfo(prev => ({
                                                        ...prev,
                                                        [`guardian${field.replace(' ', '')}`]: e.target.value
                                                    }))}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                    
                                    <Divider sx={{ my: 4 }} />
                                    <Typography variant="h6" gutterBottom>
                                        Address Information
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                label="Present Address"
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                multiline
                                                rows={4}
                                                value={addressInfo.presentAddress}
                                                onChange={(e) => setAddressInfo(prev => ({ ...prev, presentAddress: e.target.value }))}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                label="Permanent Address"
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                multiline
                                                rows={4}
                                                value={addressInfo.permanentAddress}
                                                onChange={(e) => setAddressInfo(prev => ({ ...prev, permanentAddress: e.target.value }))}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Phone 1"
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                value={addressInfo.phone1}
                                                onChange={(e) => setAddressInfo(prev => ({ ...prev, phone1: e.target.value }))}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Phone 2"
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                value={addressInfo.phone2}
                                                onChange={(e) => setAddressInfo(prev => ({ ...prev, phone2: e.target.value }))}
                                            />
                                        </Grid>
                                    </Grid>
                    
                                    <Divider sx={{ my: 4 }} />
                                    <Typography variant="h6" gutterBottom>
                                        Emergency Contact Information
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Emergency Contact Number"
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                value={addressInfo.emergencyContactNumber}
                                                onChange={(e) => setAddressInfo(prev => ({ ...prev, emergencyContactNumber: e.target.value }))}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Emergency Contact Name"
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                value={addressInfo.emergencyContactName}
                                                onChange={(e) => setAddressInfo(prev => ({ ...prev, emergencyContactName: e.target.value }))}
                                            />
                                        </Grid>
                                    </Grid>
                    
                                    <Divider sx={{ my: 4 }} />
                                    <Typography variant="h6" gutterBottom>
                                        Previous Schooling Information
                                    </Typography>
                                    {previousSchools.map((school, index) => (
                                        <Grid container spacing={2} key={index}>
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    label="School Name"
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    value={school.name}
                                                    onChange={(e) => {
                                                        const updatedSchools = [...previousSchools];
                                                        updatedSchools[index].name = e.target.value;
                                                        setPreviousSchools(updatedSchools);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    label="Grade From"
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    value={school.gradeFrom}
                                                    onChange={(e) => {
                                                        const updatedSchools = [...previousSchools];
                                                        updatedSchools[index].gradeFrom = e.target.value;
                                                        setPreviousSchools(updatedSchools);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    label="Grade To"
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    value={school.gradeTo}
                                                    onChange={(e) => {
                                                        const updatedSchools = [...previousSchools];
                                                        updatedSchools[index].gradeTo = e.target.value;
                                                        setPreviousSchools(updatedSchools);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    label="From Date"
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    type="date"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={school.dateFrom}
                                                    onChange={(e) => {
                                                        const updatedSchools = [...previousSchools];
                                                        updatedSchools[index].dateFrom = e.target.value;
                                                        setPreviousSchools(updatedSchools);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    label="To Date"
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    type="date"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={school.dateTo}
                                                    onChange={(e) => {
                                                        const updatedSchools = [...previousSchools];
                                                        updatedSchools[index].dateTo = e.target.value;
                                                        setPreviousSchools(updatedSchools);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={1}>
                                                <IconButton onClick={() => handleRemoveSchool(index)} color="secondary">
                                                    <Remove />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    ))}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<Add />}
                                        onClick={handleAddSchool}
                                        sx={{ mt: 2 }}
                                    >
                                        Add School
                                    </Button>
                    
                                    <Divider sx={{ my: 4 }} />
                                    <FancyUploadSection
                                        onFileChange={handleSignatureFileChange}
                                        filePreview={signatureImage}
                                    />
                    
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        sx={{ mt: 4, mb: 2 }}
                                    >
                                        Submit Application
                                    </Button>
                                </Box>
                                
                                <ThankYouModal isVisible={isModalVisible} onClose={closeModal} />
                            </Paper>
                        );
                    }
                    
 export default AdmissionForm;
                    
